
import { CardHeader } from './cardHeader/CardHeader';
import styles from './card.module.css';
import { List } from '../list/List';

export function Card({ cardText1, cardText2, image1, image2, list }) {


  return (
    <>
      <div className={styles.mainCard}>
        <CardHeader text={'Описание продукта'} />
        <div className={styles.mainGrid}>
          <div className={styles.mainCardTextContrainer}>
            {cardText1?.map((item, id) => (
              <p key={id} className={styles.mainCardText}>{item}</p>
            ))}

          </div>
          <div className={styles.mainCardImageContainer}>
            <img
              className={styles.mainCardImage}
              src={image1}
              alt="Масляный фильтр"
              loading="lazy"
            />
          </div>
        </div>

        <div>
          <CardHeader text={'Преимущества'} />
          <div className={styles.mainGrid} style={{ gap: '20px' }}>
            <div className={styles.mainCardImageContainer}>
              <img
                className={styles.mainCardImage}
                src={image2}
                alt="Масляный фильтр"
                loading="lazy"
              />
            </div>
            <List listItems={list} />
          </div>
        </div>
      </div>
    </>
  );
}
